import { GlobalToastProvider } from '@higherlogic/ocfe/src/toast';
import React from 'react';
import GlobalBioBubbleProvider from 'src/BioBubble/GlobalBioBubbleProvider';
import { FilePickerContext } from 'src/FilePicker/FilePickerConfig';
import { useFilePickerConfig } from 'src/FilePicker/api';
import { TaggingContext } from 'src/ItemTags/TaggingConfig';
import { useTaggingConfig } from 'src/ItemTags/api';
import { TinyMCEContext } from 'src/TinyMCE/TinyMCEConfig';
import { useTinyMCEConfig } from 'src/TinyMCE/api';
import { GlobalDataContext } from './GlobalData';
import GlobalThemeProvider from './GlobalThemeProvider';

const GlobalContextsContainer: React.FCC<{ globalData: GlobalData }> = ({ globalData, children }) => {
    const tinyMCELoadable = useTinyMCEConfig();
    const taggingLoadable = useTaggingConfig();
    const filePickerLoadable = useFilePickerConfig();

    return (
        <GlobalDataContext.Provider value={globalData}>
            <TinyMCEContext.Provider value={tinyMCELoadable}>
                <TaggingContext.Provider value={taggingLoadable}>
                    <FilePickerContext.Provider value={filePickerLoadable}>
                        <GlobalThemeProvider>
                            <GlobalBioBubbleProvider>
                                <GlobalToastProvider>{children}</GlobalToastProvider>
                            </GlobalBioBubbleProvider>
                        </GlobalThemeProvider>
                    </FilePickerContext.Provider>
                </TaggingContext.Provider>
            </TinyMCEContext.Provider>
        </GlobalDataContext.Provider>
    );
};

export default GlobalContextsContainer;
